// Single source of truth for "may this user open this nav page?".
//
// The sidebar (SidebarContent) and refresh() in App.js both need this answer.
// They used to compute it differently: the sidebar honoured `everyone`,
// `module` and `masterAdminOnly`, while refresh() only checked
// `permissions.includes(id)`. Pages whose id is not itself a permission key -
// My Account (`everyone`), Outreach Approval and Automation Approvals
// (`module: "revenue_engine"`) - were shown in the sidebar, but every click
// made refresh() treat them as forbidden and bounce the user to the first
// permitted page (the CEO Command Center).

export function isNavItemAllowed(item, permissions, user) {
  if (!item) return false;
  const perms = permissions || [];
  const isMasterAdmin = user?.role === "Master Administrator";
  if (item.masterAdminOnly && !isMasterAdmin) return false;
  if (item.roles && !item.roles.includes(user?.role)) return false;
  return Boolean(item.everyone || perms.includes(item.module || item.id) || item.masterAdminOnly);
}

// For a page id (refresh()'s `module`): a nav page follows the nav rule above;
// anything else (an internal module id with no nav entry) must be a granted
// permission key.
export function isModuleAllowed(moduleId, nav, permissions, user) {
  const item = (nav || []).find((entry) => entry.id === moduleId);
  if (item) return isNavItemAllowed(item, permissions, user);
  return (permissions || []).includes(moduleId);
}
